// "For this step" in cooking mode: the ingredients a step's English text mentions, never invented.
// An ingredient matches when the step names it in full, or names its core phrase once qualifiers
// ("thin", "big", "soaked") and generic forms ("powder", "paste", "leaves") are dropped — the
// whole core phrase must appear, so "coconut oil" never pulls in "coconut milk".
import type { Ingredient } from '../types';

const QUALIFIERS = new Set(['thin', 'thick', 'big', 'small', 'large', 'medium', 'fresh', 'chopped', 'sliced',
  'diced', 'grated', 'soaked', 'boiled', 'roasted', 'crushed', 'finely', 'whole', 'dry', 'dried']);
const GENERIC = new Set(['powder', 'paste', 'leaves', 'leaf', 'seeds', 'seed']);

function tokens(s: string): string[] {
  return s.toLowerCase().replace(/\([^)]*\)/g, ' ').split(/[^a-z]+/).filter(Boolean);
}

// mentions checks a phrase as whole words, allowing a plural on its last word
// (onion/onions, tomato/tomatoes, chilli/chillies).
function mentions(text: string, words: string[]): boolean {
  if (words.length === 0) return false;
  const head = words.slice(0, -1).join(' ');
  const last = words[words.length - 1];
  const forms = [last, last + 's', last + 'es', last.endsWith('y') ? last.slice(0, -1) + 'ies' : ''].filter(Boolean);
  return forms.some((f) => text.includes(' ' + (head ? head + ' ' : '') + f + ' '));
}

export function ingredientsForStep(stepEN: string, ingredientsEN: Ingredient[]): number[] {
  const text = ' ' + tokens(stepEN).join(' ') + ' ';
  const out: number[] = [];
  ingredientsEN.forEach((ing, i) => {
    const all = tokens(ing.name);
    const core = all.filter((w) => !QUALIFIERS.has(w));
    const essential = core.filter((w) => !GENERIC.has(w));
    if (mentions(text, all) || mentions(text, core) || (essential.length > 0 && mentions(text, essential))) out.push(i);
  });
  return out;
}
